import React from 'react';
import {ModalRequest} from "../common";

const FormWaitingModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return (
    <ModalRequest
      open={open}
      onClose={onClose}
      title="Невозможно создать заявку"
    >
      <p className="text-mainBlack">
        Если форма уже загружена, то она на расмотрении.  Об активации учетной записи вам придет письмо на почту
      </p>
    </ModalRequest>
  )
};

export default FormWaitingModal;
